module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-75-min.59cce0e1.jpg";